<footer class="border-top footer footer-paragraph">
    <div style="width: auto; max-width: 1140px; padding: 0 15px 0 15px; margin: 0px auto 0px auto;">
      <div class="flex-wrapper no-wrap" style="margin: 0 auto 0 auto; ">
        <div id="footer-text">Authorised and regulated by the Solicitors Regulation Authority (No.61877) | Copyright HF Limited {{this.currentDate.getFullYear()}}</div>
        <div id="footer-logo">
          <iframe style="border: 0px; margin: 0px; padding: 0px; background-color: transparent; top: 0px; left: 0px;" width="125" height="75" src="https://cdn.yoshki.com/iframe/55845r.html" frameborder="0" scrolling="no" tabindex="9"></iframe>
        </div>
      </div>
    </div>
  </footer>
